import { FC, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
import { usePermissions } from "../../context/PermissionsContext";
import { SummaryData } from "../../Typings/dataListing";
import { getSummaryById } from "../../redux/actions/summaryAction";
import { AppDispatch } from "../../redux/store";

const SummaryView: FC = () => {
  const { summaryid } = useParams<{ summaryid: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const [summaryData, setSummaryData] = useState<SummaryData | null>(null);
  const { permissions } = usePermissions();
  const roleid = localStorage.getItem("roleid") ?? "";

  useEffect(() => {
    if (summaryid) {
      const payload = { summaryid: parseInt(summaryid, 10) };
      dispatch(
        getSummaryById(payload, (response: any) => {
          const summaryData = response?.data;
          if (summaryData) {
            setSummaryData(summaryData);
          }
        })
      );
    }
  }, [summaryid, dispatch]);

  const formatCurrency = (value: number | undefined) => {
    return value ? `$${value.toFixed(2)}` : "-";
  };

  const formatBoolean = (value: boolean | undefined) => {
    return value ? "Yes" : "No";
  };

  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">F2F  Summary</span>
              {summaryData?.market_name || "N/A"}
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-6 col-md-4 col-lg-3">
                Market Name
                <span className="d-block pt-1">
                  {summaryData?.market_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile Name
                <span className="d-block pt-1">
                  {summaryData?.profile_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Profile ID
                <span className="d-block pt-1">
                  {summaryData?.profile_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Market ID
                <span className="d-block pt-1">
                  {summaryData?.market_id || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                State
                <span className="d-block pt-1">
                  {summaryData?.state || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                City
                <span className="d-block pt-1">{summaryData?.city || "-"}</span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                County
                <span className="d-block pt-1">
                  {summaryData?.county || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                ZIP
                <span className="d-block pt-1">{summaryData?.zip || "-"}</span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Address
                <span className="d-block pt-1">
                  {summaryData?.address || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Latitude
                <span className="d-block pt-1">
                  {summaryData?.latitude || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Longitude
                <span className="d-block pt-1">
                  {summaryData?.longitude || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Year Founded
                <span className="d-block pt-1">
                  {summaryData?.year_founded || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Multiple Locations
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.multiple_locs)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Year Round
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.year_round)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Season
                <span className="d-block pt-1">
                  {summaryData?.season || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Days of Operation
                <span className="d-block pt-1">
                  {summaryData?.days_of_operation || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Hours of Operation
                <span className="d-block pt-1">
                  {summaryData?.hours_of_operation || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Host Name
                <span className="d-block pt-1">
                  {summaryData?.host_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Incorporated
                <span className="d-block pt-1">
                  {summaryData?.incorporated || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                FMC Member
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.fmc_member)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Wholesome Wave Member
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.wholesome_wave_member)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Other Associations
                <span className="d-block pt-1">
                  {summaryData?.other_associations || "-"}
                </span>
              </li>
              
              <li className="col-6 col-md-4 col-lg-3">
                Has Mission Statement
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.mission_statement)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                On Website
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.ms_website)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                In Manual
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.ms_manual)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                In Market Promos
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.ms_market_promos)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Inclusive Mission Statement
                <span className="d-block pt-1">
                  {formatBoolean(summaryData?.has_mission_statement_inclusive)}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Promotes DEI
                <span className="d-block pt-1">
                  {formatBoolean(
                    summaryData?.has_mission_statement_promote_dei
                  )}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Diverse Cultures
                <span className="d-block pt-1">
                  {formatBoolean(
                    summaryData?.has_mission_statement_diverse_cultures
                  )}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Diverse Voices Influence
                <span className="d-block pt-1">
                  {summaryData?.diverse_voices_influence || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Voucher 1
                <span className="d-block pt-1">
                  {summaryData?.voucher1_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Voucher 2
                <span className="d-block pt-1">
                  {summaryData?.voucher2_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Voucher 3
                <span className="d-block pt-1">
                  {summaryData?.voucher3_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4 col-lg-3">
                Voucher 4
                <span className="d-block pt-1">
                  {summaryData?.voucher4_name || "-"}
                </span>
              </li>
              <li className="col-6 col-md-4">
                Voucher 5
                <span className="d-block pt-1">
                  {summaryData?.voucher5_name || "-"}
                </span>
              </li>
              <li className="col-12">
                Mission Statement Text
                <span className="d-block pt-1">
                  {summaryData?.mission_statement_text || "-"}
                </span>
              </li>
            </ul>

            <div className="pt-5 text-end">
              <NavLink to="/summary">
                <button type="button" className="formBtn cancel">
                  Back to List
                </button>
              </NavLink>
              {permissions && roleid && (
                <NavLink to={`/summary/edit/${summaryid}`}>
                  <button type="button" className="ms-3 formBtn">
                    Edit Details
                  </button>
                </NavLink>
              )}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default SummaryView;
